var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNzFundsNzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 119.998L135 105.002L135 89.9998L90 89.9998L90 105.002L109.5 105.002L90 119.998L90 135L135 135L135 119.998L115.5 119.998Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0018 45L14.9965 25.5004L29.9982 45L45 45L45 8.16601e-06L29.9982 7.98712e-06L29.9982 19.4996L15.0018 7.80829e-06L5.36619e-07 7.62939e-06L0 45L15.0018 45Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 135L135 1.52588e-05L112.5 1.32918e-05L1.52588e-05 135L22.5 135Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzFundsNzLogo);
export default __webpack_public_path__ + "static/media/nz-funds-nz-logo.61a01de0a1bcc79b79aea93087290722.svg";
export { ForwardRef as ReactComponent };